import * as React from "react";

import AudioVolumeSpeaker from "./AudioVolumeSpeaker";
import AudioVolumeCaret from "./AudioVolumeCaret";

const AudioVolume: React.FC = () => (
  <>
    <AudioVolumeSpeaker />
    <AudioVolumeCaret />
  </>
);
export default AudioVolume;
